import React, { memo, useMemo } from 'react';
import { pick } from 'ramda';

import { View } from '../Base';
import {
  ADDRESS_SHORT,
  MANIFEST_LOCATION,
  PARCEL_NUMBER,
  POSTCODE,
  WINDOW,
} from '../../constants/strings';
import { getAddress } from '../../features/request/model';
import { getServiceWindow } from '../../models/stop';
import { getParcelNumber } from '../../utils/getParcelNumber';

const ParcelRequestContext = ({ stop, textStyle }) => {
  const request = stop.requests[0];

  const address = useMemo(() => getAddress(request.address), [request]);

  const window = useMemo(
    () =>
      getServiceWindow({
        ...pick(['serviceStartTime', 'serviceEndTime'], request),
        displayServiceWindow: true,
      }),
    [request]
  );

  const parcelNumber = useMemo(
    () => getParcelNumber(request.labelNumber),
    [request]
  );

  return (
    <>
      <View className={textStyle.row}>
        <span className={textStyle.label}>{`${PARCEL_NUMBER}:`}</span>
        <span className={textStyle.value}>{parcelNumber}</span>
      </View>
      <View className={textStyle.row}>
        <span className={textStyle.label}>{`${ADDRESS_SHORT}:`}</span>
        <span className={textStyle.value}>{address}</span>
        <span className={textStyle.spaceBetween} />
        <span className={textStyle.label}>{`${POSTCODE}:`}</span>
        <span className={textStyle.value}>
          {request.address?.postcode || stop.postcode}
        </span>
      </View>
      {request.manifestLocation && (
        <View className={textStyle.row}>
          <span className={textStyle.label}>{`${MANIFEST_LOCATION}:`}</span>
          <span className={textStyle.value}>{request.manifestLocation}</span>
        </View>
      )}
      <View className={textStyle.row}>
        <span className={textStyle.label}>{`${WINDOW}:`}</span>
        <span className={textStyle.value}>{window}</span>
      </View>
    </>
  );
};

export default memo(ParcelRequestContext);
